"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESTINATION_TYPES = exports.DESTINATION_ENDPOINT__METHODS = void 0;
var DESTINATION_TYPES = exports.DESTINATION_TYPES = ['LAMBDA', 'ENDPOINT', 'FTP', 'S3', 'OTHER'];
var DESTINATION_ENDPOINT__METHODS = exports.DESTINATION_ENDPOINT__METHODS = ['POST', 'PUT', 'PATCH'];